import React from "react";
import { DeleteDialog, Modal } from "../../../components";
import FileUploadModal from "../files/fileuploadmodal";
import FlightDetail from "../flightdetails/generalflightdetail";
import RetrieveFlights from "../retrieveflights/retrieveflights";
import SegmentList from "../segmentdetail/flightsegmentlist";
import { ButtonSecondary } from "components/Atoms/Button";
import { type UploadFilesConfig, uploadFilesToCoreApi } from "utilities/fileUploadUtils";

interface Props {
  onExistingFlightAdded: (segments: server.dto.FlightSegment[]) => void
  onManualEntryClicked: () => void

  onFlightEdit: () => void
  onSegmentEdit: (segment: server.dto.FlightSegment) => void
  onSegmentDelete: (newFlight: server.dto.Flight) => void
  onFilesUploaded: () => void

  onModalClose: () => void

  flight: server.dto.Flight
}

interface State {
  showFlightlookup: boolean
  deletingSegmentId?: number
  showFileUpload: boolean
}

export default class FlightDetailPage extends React.Component<Props, State> {
  state: State = {
    showFlightlookup: false,
    deletingSegmentId: null,
    showFileUpload: false
  };

  onSegmentDeleteClick = (segment: server.dto.FlightSegment) => {
    this.setState({ deletingSegmentId: segment.id });
  };

  deleteSelectedSegment = async () => {
    const result = await window.Api.Flights.DeleteSegment(this.state.deletingSegmentId);

    this.props.onSegmentDelete(result.data);

    this.setState({ deletingSegmentId: null });
  };

  uploadFiles = (files: File[], uploadConfig: UploadFilesConfig) => {
    return uploadFilesToCoreApi(
      window.CoreApi.File.UploadFlightFiles,
      window.CoreApi.File.UploadFlightFiles.absoluteUrl(),
      {
        files,
        flightId: this.props.flight.id
      },
      uploadConfig
    );
  };

  public render(): JSX.Element {
    const { flight } = this.props;

    const headerButton = flight.permissions.canModify
      ? <ButtonSecondary onClick={() => { this.setState({ showFlightlookup: true }); }} label={RESX.Flight.AddSegment} />
      : null;

    return <>
      <Modal
        handleClose={this.props.onModalClose}
        title={RESX.Flight.resxFlight}
        isOpen
        width={"large"}
        hasAutoScrollBox
        headerButton={headerButton}
      >
        <div className="grow1 scrollbox-auto">
          <FlightDetail
            flight={flight}
            onFlightEditClicked={this.props.onFlightEdit}
            onFilesAddClick={() => { this.setState({ showFileUpload: true }); }}
          />
          <SegmentList
            flight={flight}
            segments={flight.segments}
            connectionTimes={flight.connectionTimes}
            onSegmentDelete={this.onSegmentDeleteClick}
            onSegmentEdit={this.props.onSegmentEdit}
          />
        </div>
      </Modal>
      {this.state.showFlightlookup && (
        <Modal
          title={RESX.Flight.FlightLookup}
          width={"large"}
          minHeight={450}
          height={600}
          hasAutoScrollBox
          isOpen={this.state.showFlightlookup}
          handleClose={() => { this.setState({ showFlightlookup: false }); }}
        >
          <RetrieveFlights
            onManualEntryClicked={this.props.onManualEntryClicked}
            onSelectWithSegmentClicked={this.props.onExistingFlightAdded}
          />
        </Modal>
      )}
      <DeleteDialog
        isOpen={!!this.state.deletingSegmentId}
        message={RESX.GeneralWarnings.AreYouSure}
        handleClose={() => { this.setState({ deletingSegmentId: null }); }}
        onDelete={this.deleteSelectedSegment} />
      <Modal
        title={RESX.File.Files}
        isOpen={this.state.showFileUpload}
        width={"small"}
        minHeight={400}
        height={750}
        handleClose={() => { this.setState({ showFileUpload: false }); }}
      >
        <FileUploadModal
          canEdit={this.props.flight.permissions.canModify}
          files={this.props.flight.files}
          onFilesChanged={this.props.onFilesUploaded}
          upload={this.uploadFiles}
          deleteEndpoint={window.CoreApi.File.DeleteFlightFile}
          renameEndpoint={window.CoreApi.File.SetFlightFileProperties}
        />
      </Modal>
    </>;
  }
}
